import React from "react";
import Styles from './styles.module.scss';

import avatar from '../../theme/assets/other/lp_cabinet_avatar.png';
import accountIcon from '../../theme/assets/svg/lp_settings_account_icon.svg';
import walletIcon from '../../theme/assets/svg/lp_settings_wallet_icon.svg';
import allocationIcon from '../../theme/assets/svg/lp_settings_allocation_icon.svg';

import {useSelector} from "react-redux";
import {walletShorter} from "../../helpers/walletShorter";
import {useTranslation} from "react-i18next";


const SettingsNavigation = (props) => {
    const {currentTab, setCurrentTab} = props;
    const { t } = useTranslation();

    const userData = useSelector(store => store.cabinet.userData);
    const isComingSoon = useSelector(store => store.main.isComingSoon);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.userWrap}`}>
                    <div className={`${Styles.avatarWrap}`}>
                        {userData ? <img src={userData?.user?.avatar_url || avatar} alt="avatar"/> : null}
                    </div>
                    <div className={`${Styles.userBox}`}>
                        <div className={`${Styles.userBoxWallet}`}>{walletShorter(userData?.user?.wallet)}</div>
                        <div className={`${Styles.userBoxName}`}>{userData?.user?.name}</div>
                    </div>
                </div>
                <div className={`${Styles.navWrap}`}>
                    {isComingSoon ?
                        null :
                        <div className={`${Styles.navItem} ${currentTab === 'allocation' ? Styles.navItemActive : null}`} onClick={()=>{setCurrentTab('allocation')}}>
                            <div className={`${Styles.navItemIcon}`}>
                                <img src={allocationIcon} alt="Allocation"/>
                            </div>
                            <div className={`${Styles.navItemText}`}>{t('Аллокации')}</div>
                        </div>
                    }
                    <div className={`${Styles.navItem} ${currentTab === 'account' ? Styles.navItemActive : null}`} onClick={()=>{setCurrentTab('account')}}>
                        <div className={`${Styles.navItemIcon}`}>
                            <img src={accountIcon} alt="Account"/>
                        </div>
                        <div className={`${Styles.navItemText}`}>{t('Аккаунт')}</div>
                    </div>
                    {isComingSoon ?
                        null :
                        <div className={`${Styles.navItem} ${currentTab === 'wallets' ? Styles.navItemActive : null}`} onClick={()=>{setCurrentTab('wallets')}}>
                            <div className={`${Styles.navItemIcon}`}>
                                <img src={walletIcon} alt="Wallets"/>
                            </div>
                            <div className={`${Styles.navItemText}`}>{t('Кошельки')}</div>
                        </div>
                    }
                </div>
            </div>
        </section>
    );
};

export default SettingsNavigation;